import notSet from './notSet';

export default val => !notSet(val);



/** WEBPACK FOOTER **
 ** ./src/utils/isSet.js
 **/